var blob = new Blob(["var fakeIdToID={};addEventListener(\"message\",function(event){try{var{data={}}=event;var{action,fakeId,time}=data;switch(action){case'setInterval':fakeIdToID[fakeId]=setInterval(function(){postMessage({fakeId});},time);break;case'clearInterval':if(fakeIdToID.hasOwnProperty(fakeId)){clearInterval(fakeIdToID[fakeId]);delete fakeIdToID[fakeId];}\nbreak;case'setTimeout':fakeIdToID[fakeId]=setTimeout(function(){postMessage({fakeId});if(fakeIdToID.hasOwnProperty(fakeId)){delete fakeIdToID[fakeId];}},time);break;case'clearTimeout':if(fakeIdToID.hasOwnProperty(fakeId)){clearTimeout(fakeIdToID[fakeId]);delete fakeIdToID[fakeId];}\nbreak;default:break;}}catch(error){postMessage({error})}})"]);
var workerScript = window.URL.createObjectURL(blob);
var worker,
    fakeIdToCallback = {},
    currentFakeId = 0,
    maxFakeId = 0x7fffffff;

function getFakeId() {
  do {
    if (currentFakeId === maxFakeId) {
      currentFakeId = 0;
    } else {
      currentFakeId++;
    }
  } while (currentFakeId in fakeIdToCallback);

  return currentFakeId;
}

var setIntervalWarp;
var setTimeoutWarp;
var clearIntervalWarp;
var clearTimeoutWarp;

if (window.HACK_TIMER_WORKER && 'setIntervalWarp' in window.HACK_TIMER_WORKER && 'setTimeoutWarp' in window.HACK_TIMER_WORKER && 'clearIntervalWarp' in window.HACK_TIMER_WORKER && 'clearTimeoutWarp' in window.HACK_TIMER_WORKER) {
  setIntervalWarp = window.HACK_TIMER_WORKER.setIntervalWarp;
  setTimeoutWarp = window.HACK_TIMER_WORKER.setTimeoutWarp;
  clearIntervalWarp = window.HACK_TIMER_WORKER.clearIntervalWarp;
  clearTimeoutWarp = window.HACK_TIMER_WORKER.clearTimeoutWarp;
} else {
  if (window.Worker) {
    worker = new Worker(workerScript);

    setIntervalWarp = function setIntervalWarp(cb, time) {
      var keepAlive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!cb || typeof cb !== 'function') {
        throw new Error('cb must be a function');
      }

      var fakeId = getFakeId();

      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      fakeIdToCallback[fakeId] = {
        cb: cb,
        param: rest,
        keepAlive: !!keepAlive,
        type: 'setInterval'
      };
      worker.postMessage({
        action: 'setInterval',
        fakeId: fakeId,
        time: time
      });
      return fakeId;
    };

    clearIntervalWarp = function clearIntervalWarp(fakeId) {
      if (typeof fakeId === 'number' && fakeId in fakeIdToCallback) {
        delete fakeIdToCallback[fakeId];
        worker.postMessage({
          action: 'clearInterval',
          fakeId: fakeId
        });
      }
    };

    setTimeoutWarp = function setTimeoutWarp(cb, time) {
      var keepAlive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!cb || typeof cb !== 'function') {
        throw new Error('cb must be a function');
      }

      var fakeId = getFakeId();

      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }

      fakeIdToCallback[fakeId] = {
        cb: cb,
        param: rest,
        keepAlive: !!keepAlive,
        type: 'setTimeout'
      };
      worker.postMessage({
        action: 'setTimeout',
        fakeId: fakeId,
        time: time
      });
      return fakeId;
    };

    clearTimeoutWarp = function clearTimeoutWarp(fakeId) {
      if (typeof fakeId === 'number' && fakeId in fakeIdToCallback) {
        delete fakeIdToCallback[fakeId];
        worker.postMessage({
          action: 'clearTimeout',
          fakeId: fakeId
        });
      }
    };

    worker.addEventListener('message', function (event) {
      var data = event.data;
      var fakeId = data.fakeId;

      if (fakeId in fakeIdToCallback) {
        var _ref = fakeIdToCallback[fakeId] || {},
            cb = _ref.cb,
            param = _ref.param,
            keepAlive = _ref.keepAlive,
            type = _ref.type;

        if (type !== 'setInterval') {
          delete fakeIdToCallback[fakeId];
        }

        if (!keepAlive && document.hidden) {
          return;
        }

        if (typeof cb === 'function') {
          try {
            cb.apply(window, param);
          } catch (error) {
            console.error('Error when parse callback function, code %s', error);
          }
        }
      }
    });
    worker.addEventListener('error', function (error) {
      console.error(error);
    });
  } else {
    setIntervalWarp = setInterval;
    setTimeoutWarp = setTimeout;
    clearIntervalWarp = clearInterval;
    clearTimeoutWarp = clearTimeout;
    console.error('the browser not support web worker, fallback to unWarp function!');
  }
}

var index = {
  setIntervalWarp: setIntervalWarp,
  setTimeoutWarp: setTimeoutWarp,
  clearIntervalWarp: clearIntervalWarp,
  clearTimeoutWarp: clearTimeoutWarp
};

export default index;
